import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { NotFoundPage } from './NotFoundPage';
import { getCity } from '../data/cityData';
import { cityPath } from '../utils/seo';
/**
 * The city landing pages previously lived at `/ventura-county/<slug>` and now
 * live at `/service-areas/<slug>`.
 *
 * A single topic must resolve to a single indexable URL or the two versions
 * compete with each other, so the old path redirects to the new canonical one
 * instead of rendering a duplicate page. Any external link or previously
 * indexed URL still lands on the right page.
 */
export function CityAliasRedirect() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const city = slug ? getCity(slug) : undefined;
  if (!city) {
    return <NotFoundPage data-id="element-627" data-mp="3aoao68k5g1wr" />;
  }
  return <Navigate to={cityPath(city.slug)} replace data-id="element-628" data-mp="1u7oj14lvy8ug" />;
}